import React from 'react'
import {Api2CartConnectionPage} from '../api2cart/Api2CartConnectionPage'
import {getApi2CartConnectionConfig} from '../api2cart/config'
import {OrderType} from '../../../../../orders/core/_const'

const ConnectWooCommerce: React.FC = () => {
  return <Api2CartConnectionPage config={getApi2CartConnectionConfig(OrderType.WOOCOMMERCE)} />
}

export {ConnectWooCommerce}
